export const baseURL = "https://vhd.betaphase.in";
